import React from "react";
import styles from "./StageSection.module.scss";
import { type StepContent } from "../types";
import { StepRenderer } from "./StepRenderer";

interface StageSectionProps {
  title?: string;
  isMainTitle?: boolean;
  steps: { index: string | number; content: StepContent[] }[];
  StepRenderer?: typeof StepRenderer;
  copyProps?: {
    resolveBlockValue: (block: StepContent) => string;
    onCopy: (value: string) => void;
  };
  next?: () => void;
  input?: { tableUrl: string; setTableUrl: (url: string) => void };
  onSubmit?: () => void;
  isConnecting?: boolean;
  setIsModalOpen?: (open: boolean) => void;
  useDots?: boolean;
}

export const StageSection: React.FC<StageSectionProps> = ({
  title,
  isMainTitle = false,
  steps,
  StepRenderer: Renderer = StepRenderer,
  copyProps,
  next,
  input,
  onSubmit,
  isConnecting,
  useDots = false,
}) => {
  return (
    <div className={styles.instructionsContent}>
      <h2
        className={isMainTitle ? styles.sectionMainTitle : styles.sectionTitle}
      >
        {title}
      </h2>

      <ol className={styles.stepList}>
        {steps.map(({ index, content }) => (
          <li key={index} className={styles.stepItem}>
            {useDots ? (
              <span className={styles.stepDot}></span>
            ) : (
              <span className={styles.stepNumber}>{index}</span>
            )}
            <div className={styles.stepContent}>
              {content.map((block, i) => (
                <Renderer key={i} block={block} index={i} {...copyProps} />
              ))}
            </div>
          </li>
        ))}
      </ol>

      {input && (
        <div>
          <div className={styles.inputGroup}>
            <div className={styles.inputLabel}>Ссылка</div>
            <input
              className={styles.input}
              type="text"
              value={input.tableUrl}
              onChange={(e) => input.setTableUrl(e.target.value)}
            />
            <button
              className={styles.inputSubmit}
              disabled={isConnecting || !input.tableUrl.trim()}
              onClick={onSubmit}
            >
              {isConnecting ? (
                <div className={styles.spinner}></div>
              ) : (
                "Отправить"
              )}
            </button>
          </div>
          <div className={styles.instructionsButtonsWrap}>
            <button
              className={styles.secondaryButton}
              onClick={(e) => {
                e.preventDefault();
                window.open("https://t.me/selleralarm_support_bot", "_blank");
              }}
            >
              Поддержка
            </button>
          </div>
        </div>
      )}

      {next && (
        <button
          className={styles.primaryButton}
          onClick={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            next();
          }}
        >
          Далее
        </button>
      )}
    </div>
  );
};
